import React from 'react';
import NumericStringInput from './NumericStringInput';

import './index.css';
import withViewContext from './withViewContext';

const SocialSecurity = props => (
  <NumericStringInput {...props} format="###-##-####" />
);

export default withViewContext(SocialSecurity);
